import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { RichText } from '@preventx/prismic-services';
import { List, ListItem, UnorderedListStyle } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

export type UnorderedListProps =
  SliceComponentProps<Content.UnorderedListSlice>;

const UnorderedList = ({ slice }: UnorderedListProps) => {
  const { id, primary } = slice;
  const { list_type, first_layer, secondary_layer } = primary;

  const style = {
    Default: undefined,
    'List Style - Disc': 'list-style-type-disc' satisfies UnorderedListStyle,
    'List Style - None': 'list-style-type-none' satisfies UnorderedListStyle,
    'List Style - Square':
      'list-style-type-square' satisfies UnorderedListStyle,
    'List Style - Circle':
      'list-style-type-circle' satisfies UnorderedListStyle,
  }[list_type] as UnorderedListStyle;

  const { WebsiteUrl } = applicationEnv();

  return (
    <List component="ul" style={style}>
      {first_layer.map((layer, index) => {
        const secondLayer = secondary_layer.filter(
          (secondLayer) =>
            secondLayer.layer_one_group_id === layer.layer_one_group_id,
        );

        return (
          <ListItem key={`ul-layer-one-${id}-${index + 1}`}>
            <RichText
              variant="default"
              content={layer.content}
              websiteUrl={WebsiteUrl}
            />

            {secondLayer.length > 0 && (
              <List component="ul" style={style}>
                {secondLayer.map((second) => (
                  <ListItem key={`ul-layer-two-${id}-${index + 1}`}>
                    <RichText
                      variant="default"
                      websiteUrl={WebsiteUrl}
                      content={second.content}
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};

export default UnorderedList;
